import { getTranslatedMessages } from '../translates';

const translate = getTranslatedMessages();

window.populateSelectFromAjax = function (
    apiUrl,
    postData,
    selectorElement,
    emptyOption = true,
    fnComplete = null,
    emptyLabel = null
) {
    $.post(
        apiUrl,
        postData,
        function (data) {
            const lastValue = $(selectorElement).val();

            const select = $(selectorElement).empty();

            if (emptyOption) {
                select.append("<option value=''>" + (!!emptyLabel ? emptyLabel : translate.emptySelect) + '</option>');
            }

            $.each(data, function (i, item) {
                var keys = Object.keys(item)
                    .filter((k) => k != 'id' && k != 'name')
                    .map((k) => 'data-' + k + "='" + item[k] + "'");

                select.append('<option value="' + item.id + '" ' + keys.join(' ') + '>' + item.name + '</option>');
            });

            select.val(lastValue);

            if (fnComplete) {
                fnComplete();
            }
        },
        'json'
    );
};
